import { defaultIcon } from '../util';
import { TaskStore, taskStore } from '../store';

class TaskActions {
  private taskStore: TaskStore;

  constructor(taskStore: TaskStore) {
    this.taskStore = taskStore;
  }

  updateTasks(tasks: TaskInfo[]) {
    //discard processes that are not meaningful
    //and give a default icon to any process missing one.
    this.taskStore.handleUpdateTasks(
      tasks
        .filter(
          task =>
            task.name != 'Idle' &&
            task.name != 'System' &&
            task.name != '_Total',
        )
        .map(task => {
          if (task.icon === 'null') {
            task.icon = defaultIcon;
          }
          return task;
        }),
    );
  }
}

export const taskActions = new TaskActions(taskStore);
